/**
 * Task helper functions for detecting complex task types
 */

/**
 * Extract recommended action from task description
 */
export function extractRecommendedAction(description) {
  if (!description) return null;
  
  const actionMatch = description.match(/\*\*Hva skal gjøres:\*\*([^*]+)/);
  if (actionMatch) {
    return actionMatch[1].trim();
  }
  
  const lines = description.split('\n').filter(l => l.trim());
  if (lines.length > 0) {
    return lines[0].replace(/^\*\*[^*]+\*\*\s*-?\s*/, '').trim();
  }
  
  return null;
}

/**
 * Check if task is a risk assessment task
 */
export function isRiskAssessmentTask(task) {
  const riskKeywords = ['risikovurdering', 'risikoanalyse', 'risikokartlegging'];
  const titleLower = (task.title || '').toLowerCase();
  return riskKeywords.some(keyword => titleLower.includes(keyword));
}

/**
 * Check if task is a laws/regulations task
 */
export function isLawsRegulationsTask(task) {
  const keywords = ['lover og forskrifter', 'lovkrav', 'regelverk', 'kartlegg gjeldende'];
  const titleLower = (task.title || '').toLowerCase();
  return keywords.some(keyword => titleLower.includes(keyword));
}

/**
 * Check if task is an emergency plan task
 */
export function isEmergencyPlanTask(task) {
  const keywords = ['beredskapsplan', 'beredskap', 'nødplan', 'krisehåndtering'];
  const titleLower = (task.title || '').toLowerCase();
  return keywords.some(keyword => titleLower.includes(keyword));
}

/**
 * Check if task is a stakeholder analysis task
 */
export function isStakeholderTask(task) {
  const keywords = ['interesseparter', 'kontekst', 'stakeholder'];
  const titleLower = (task.title || '').toLowerCase();
  return keywords.some(keyword => titleLower.includes(keyword));
}

/**
 * Check if task is an internal audit task
 */
export function isInternalAuditTask(task) {
  const keywords = ['intern revisjon', 'internrevisjon', 'intern audit'];
  const titleLower = (task.title || '').toLowerCase();
  return keywords.some(keyword => titleLower.includes(keyword));
}

/**
 * Check if task is a goals task
 */
export function isGoalsTask(task) {
  const keywords = ['sett mål', 'definer mål', 'målsettinger', 'kvalitetsmål'];
  const titleLower = (task.title || '').toLowerCase();
  return keywords.some(keyword => titleLower.includes(keyword));
}

/**
 * Check if task is any complex task type
 */
export function isComplexTask(task) {
  return isLawsRegulationsTask(task) || isEmergencyPlanTask(task) || 
         isStakeholderTask(task) || isInternalAuditTask(task) || isGoalsTask(task);
}

/**
 * Format file size to human readable string
 */
export function formatFileSize(bytes) {
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
  return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
}
